import { render, staticRenderFns } from "./UlLists.vue?vue&type=template&id=755fbd8c&scoped=true&"
import script from "./UlLists.vue?vue&type=script&lang=js&"
export * from "./UlLists.vue?vue&type=script&lang=js&"
import style0 from "./UlLists.vue?vue&type=style&index=0&id=755fbd8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755fbd8c",
  null
  
)

export default component.exports